module.exports = __webpack_public_path__ + "static/media/meta-img.df471acd.png";